import Request from "./request";

export default class AIAssistantService {
  static async Update(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ThirdPartyIntegration/advanceUser/updateConfigsToriChat",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async TestConfig(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ThirdPartyIntegration/advanceUser/testConfigsToriChat",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async searchExpertKnowledge(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantExpertKnowledge/searchExpertKnowledge",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async addNewExpertKnowledge(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantExpertKnowledge/addNewExpertKnowledge",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async deleteExpertKnowledge(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantExpertKnowledge/deleteExpertKnowledge",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async updateExpertKnowledge(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantExpertKnowledge/updateExpertKnowledge",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async addNewGeneralInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantGeneralInfo/addNewGeneralInfo",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async searchGeneralInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantGeneralInfo/searchGeneralInfo",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async updateGeneralInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantGeneralInfo/updateGeneralInfo",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
  static async deleteMerchantExpertInfo(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/MerchantGeneralInfo/deleteGeneralInfo",
        data: data,
        newUrl: process.env.REACT_APP_API_TORICHAT_URL,
        headers: {
          merchantCode: data.merchantCode,
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true, ...result });
        } else {
          return resolve({ isSuccess: false, ...result });
        }
      });
    });
  }
}
